import { useEffect, useRef } from 'react';
import translations from '../translations';

const Sidebar = ({ isOpen, setIsOpen, lang, userName, logoutButton, isMobile }) => {
  const sidebarRef = useRef(null);

  useEffect(() => {
    const handleTouchOutside = (event) => {
      if (
        isMobile &&
        isOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('touchstart', handleTouchOutside);
    return () => {
      document.removeEventListener('touchstart', handleTouchOutside);
    };
  }, [isOpen, setIsOpen, isMobile]);

  return (
    <div
      ref={sidebarRef}
      className={`sidebar fixed top-0 left-0 h-full z-50 ${isOpen ? 'open' : ''}`}
      style={{
        width: isOpen ? '190px' : '0',
        background: 'linear-gradient(135deg, rgba(70, 0, 130, 0.8) 0%, rgba(70, 0, 130, 0.5) 80%)',
        transition: 'width 0.4s ease',
      }}
    >
      <div className="h-full flex flex-col justify-between p-4">
        <div>
          <div className={`sidebar-content transition-opacity duration-700 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0'}`}>
            <h2 className="text-lg font-bold mb-4 font-['Inter'] text-white transform transition-transform duration-500 ease-in-out translate-y-0">
              Menú
            </h2>
            <ul className="space-y-4">
              <li>
                <a
                  href="/"
                  className="text-white hover:text-[#D1C4E9] transition-colors duration-300 ease-in-out transform hover:-translate-y-1 block"
                  data-translate="home"
                >
                  {translations[lang].home}
                </a>
              </li>
              <li>
                <a
                  href="https://kuni3d.carrd.co"
                  className="text-white hover:text-[#D1C4E9] transition-colors duration-300 ease-in-out transform hover:-translate-y-1 block"
                >
                  Portafolio
                </a>
              </li>
              <li>
                <a
                  href="#about"
                  className="text-white hover:text-[#D1C4E9] transition-colors duration-300 ease-in-out transform hover:-translate-y-1 block whitespace-nowrap"
                >
                  Acerca de
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white hover:text-[#D1C4E9] transition-colors duration-300 ease-in-out transform hover:-translate-y-1 block"
                >
                  Contacto
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className={`sidebar-content transition-opacity duration-700 ease-in-out ${isOpen ? 'opacity-100' : 'opacity-0'}`}>
          {userName && (
            <p className="text-[#D1C4E9] font-['Inter'] text-base mb-2">
              Bienvenid@, {userName}
            </p>
          )}
          {logoutButton}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
